<template>
	<div>
		<div v-if="item.type == 1" class="material-image">
			<div class="material-image-box">
				<img
					:src="item.pathUrl + '?imageMogr2/auto-orient/thumbnail/600x600/blur/1x0/quality/100|imageslim'"
					alt=""
				/>
			</div>
			<div class="material-item-name">
				<span>{{ item.title }}</span>
			</div>
		</div>
		<div v-if="item.type == 2" class="material-video">
			<div
				class="material-video-box"
				:style="{ backgroundImage: `url('${item.pathUrl}?ci-process=snapshot&time=1&format=jpg')` }"
			>
				<i class="iconfont icon-bofang1" />
			</div>
			<div class="material-item-name">
				<span>{{ item.title }}</span>
			</div>
		</div>
		<div v-if="item.type == 3" class="material-doc">
			<div class="material-doc-box">
				<svg v-if="item.originType && item.originType.search('ppt') != -1" class="icon" aria-hidden="true">
					<use xlink:href="#icon-word-2" />
				</svg>
				<svg v-if="item.originType && item.originType.search('doc') != -1" class="icon" aria-hidden="true">
					<use xlink:href="#icon-word-" />
				</svg>
				<svg v-if="item.originType && item.originType.search('pdf') != -1" class="icon" aria-hidden="true">
					<use xlink:href="#icon-word-1" />
				</svg>
				<svg v-if="item.originType && item.originType.search('xlx') != -1" class="icon" aria-hidden="true">
					<use xlink:href="#icon-word-3" />
				</svg>
			</div>
			<div class="material-item-name">
				<span>{{ item.title }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style></style>
